// extracted by mini-css-extract-plugin
export default {"files-table":"style_files-table__aXPs-"};